<mat-nav-list *ngIf="isLoggedIn">
  <ng-container *ngFor="let menuItem of filteredMenuItems">
    <div class="main-menu-item">
      <a mat-list-item
         routerLinkActive="activeLink"
         [routerLink]="menuItem.path"
      > {{menuItem.caption}} </a>
      <div class="child-menu-items" *ngIf="menuItem.childItems && menuItem.childItems.length > 0">
        <a *ngFor="let childItem of menuItem.childItems"
           class="child-menu-item"
           mat-list-item
           routerLinkActive="activeLink"
           [routerLink]="childItem.path"
        > {{childItem.caption}} </a>
      </div>
    </div>
  </ng-container>
</mat-nav-list>
<mat-nav-list *ngIf="!isLoggedIn">
  <a mat-list-item
     routerLinkActive="activeLink"
     routerLink="/login"
  > Sign In </a>
</mat-nav-list>
